import React from 'react';


function Footer() {
  return (
    <footer className="bg-purple-700 p-4 text-white text-center relative bottom-0 left-0 w-full">
      <p>&copy; 2024 Building planning, consultancy and construction.</p>
      
    </footer>
  );
}

export default Footer;
